import React from 'react'
import "./Header.css";
import { Container, Nav, Navbar, NavDropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Button } from 'antd';

function Header () {
    return (
        <Navbar collapseOnSelect className="bg-body-black" variant='dark' bg='dark' expand="lg" fixed='top' >
            <Container>
                <Navbar.Brand href="/"><img src={require( "../../images/logo.avif" )} alt="logo" height={"100%"} width={"100%"} /></Navbar.Brand>
                <Navbar.Toggle aria-controls="responsive-navbar-nav" id="navbar-custom-toggle" />
                <Navbar.Collapse id="responsive-navbar-nav" className="justify-content-end">
                    <Nav>
                        <NavDropdown title="Products" id="basic-nav-dropdown">
                            {/* <NavDropdown.Item as={Link} aria-controls="responsive-navbar-nav" onClick={() => document.getElementById( "navbar-custom-toggle" ).click()} to="/products">All Products</NavDropdown.Item> */}
                            <NavDropdown.Item as={Link} aria-controls="responsive-navbar-nav" onClick={() => document.getElementById( "navbar-custom-toggle" ).click()} to="/products-list">Products List</NavDropdown.Item>
                            <NavDropdown.Item as={Link} aria-controls="responsive-navbar-nav" onClick={() => document.getElementById( "navbar-custom-toggle" ).click()} to="/products-categories">Products Categories</NavDropdown.Item>
                        </NavDropdown>
                        <Nav.Link as={Link} to="/why-choose-us" aria-controls="responsive-navbar-nav" onClick={() => document.getElementById( "navbar-custom-toggle" ).click()}>Why Choose Us</Nav.Link>
                        <Nav.Link as={Link} to="/quality-assurance" aria-controls="responsive-navbar-nav" onClick={() => document.getElementById( "navbar-custom-toggle" ).click()}>Quality Assurance</Nav.Link>
                        <Nav.Link as={Link} to="/join-us" aria-controls="responsive-navbar-nav" onClick={() => document.getElementById( "navbar-custom-toggle" ).click()}>Join Us</Nav.Link>
                        <Nav.Link as={Link} to="/about" aria-controls="responsive-navbar-nav" onClick={() => document.getElementById( "navbar-custom-toggle" ).click()}>About Us</Nav.Link>
                        <Nav.Link as={Link} to="/contact" aria-controls="responsive-navbar-nav" onClick={() => document.getElementById( "navbar-custom-toggle" ).click()}><Button>
                            Contact Us
                        </Button></Nav.Link>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    )
}

export default Header
